/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import { GET_TUTORS_AT_SCHOOL } from 'shared/constants/gql-constants';
import Layout from 'shared/components/Layout/Layout';
import SchoolLanding from './schoolLandingPage/schoolLandingPage';

async function action({ params, client }) {
  const { schoolName, schoolCity, schoolState } = params;
  const school = schoolName.replace(/_/g, ' ');
  const city = schoolCity.replace(/_/g, ' ');
  const state = schoolState;
  try {
    const data = await client.query({
      query: GET_TUTORS_AT_SCHOOL,
      fetchPolicy: 'network-only',
      variables: {
        school,
        city,
        state,
      },
    });

    const title = `Top Tutorfly tutors at ${school}`;
    const tutors = data.data.getTutorsBySchool;

    return {
      title,
      chunks: ['schoolLanding'],
      component: (
        <Layout>
          <SchoolLanding
            title={title}
            tutors={tutors}
            city={city}
            state={state}
          />
        </Layout>
      ),
    };
  } catch (err) {
    return { redirect: '/not-found' };
  }
}

export default action;
